import { useEffect, useState } from "react";
import { _IndirectCostType, _LabourType, _ProductiveProcessType, _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { SelectLabourTypeConstants } from "./SelectLabourTypeConstants";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { toast } from "react-toastify";
import { PrintJson } from "../../theme/Component/PrintJson";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicButton } from "../../theme/Component/BasicButton";
import { SelectIndirectConstTypeEditor } from "../IndirectCostType/SelectIndirectConstTypeEditor";

export const LabourType = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_LabourType);
    const [regexStr, setregexStr] = useState<string>(null)
    const [type, settype] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [regexStr, paginador.page])

    const getLista = () => {

        instance.getLabourTypeCatalog(type, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    setLista(resp.List)
                }
            }
        )

    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDLabourType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLabourType', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo de Costo', property: 'IndirectCostTypeName', visible: true },
        // { title: 'Cuenta Contable', property: 'AccountantIDStrName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            Type: bean.Type,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Tipo de Labor" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Tipo de Labor" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Tipo de Labor` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Type", "Name", "CostingCenterStr", "IDEmployee"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Tipos de Labor" >
                    <div className="row">
                        <div className="col-md-6">

                            <label>Búsqueda por Texto</label>
                            <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />

                        </div>
                        <div className="col-md-6">
                            <SelectLabourTypeConstants idSelector={type} onChange={(e) => { settype(e) }} />

                        </div>
                        <div className="col-md-6 mt-3">
                            <BasicButton eventClick={getLista} icon="ri-folder-upload-fill" >
                                Buscar por Filtros
                            </BasicButton>
                        </div>
                        <div className="col-md-12">
                            <BasicTable
                                listButtons={listaBotones()}
                                head={head}
                                body={lista}
                                rowSet={setBean}
                                iconButtons={iconButtonsItem}
                                pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador} />
                        </div>
                    </div>
                </BasicPage>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDProductiveProcessType} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Labor</label>
                            <SelectLabourTypeConstants label=" " idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Tipo de Costo</label>
                            <SelectIndirectConstTypeEditor typereturn={15} render={bean.IndirectCostTypeName} idSelector={bean.IDIndirectCostType} onChange={(e) => { setBean({ ...bean, "IDIndirectCostType": e.IDIndirectCostType, "IndirectCostTypeName": e.Name }) }} label=" " returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('CostingCenterStr') ? 'has-error' : ''}`}>Centro de Costo</label>
                            <CostingCenterSelect fKey="Code" idSelector={bean.CostingCenterStr} onChange={(e) => { setBean({ ...bean, "CostingCenterStr": e }) }} label=" " />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}



